import {
  GET_ALL_RECEPIENTS_SUCCESS,
  GET_INBOX_LABELS_SUCCESS, GET_MAIL_BY_ID, GET_MAIL_BY_ID_SUCCESS, GetAllRecepientsSuccessAction,
  GetInboxLabelsSuccessAction, GetMailByIdAction,
  GetMailByIdSuccessAction, InboxActions,
  INVALIDATE_INBOX, MY_MAIL_ALERT, MyMailAlertAction, OTHERS_MAIL_ALERT
} from '../actions/inbox.actions';
import {Guid} from 'guid-typescript';
import { InboxModel } from '../../models/inbox.model';
import {NotifyOthersAction} from '@shared/store/actions/particle.actions';
export interface InboxState {
  invalidateId: string;
  inboxLabels: InboxModel[];
  currentlyOpenedMail: any;
  allRecepients: any;
  inboxAlertMessage: any;
}

const initialState: InboxState = <InboxState> {
  invalidateId: Guid.create().toString(),
  inboxLabels: [],
  currentlyOpenedMail: null,
  allRecepients: [],
  inboxAlertMessage: null
};

export function InboxReducer (state = initialState, action: InboxActions) {
  switch (action.type) {
    case INVALIDATE_INBOX:
      return {...state, invalidateId: Guid.create().toString()};
    case GET_INBOX_LABELS_SUCCESS:
    const inboxLabels = (action as GetInboxLabelsSuccessAction).inboxLabels;
    return {...state, inboxLabels: inboxLabels};
    case GET_MAIL_BY_ID_SUCCESS:
      const mail = (action as GetMailByIdSuccessAction).mail;
      return {...state, currentlyOpenedMail: mail};
    case GET_MAIL_BY_ID:
      return {...state, currentlyOpenedMail: null};
    case GET_ALL_RECEPIENTS_SUCCESS:
      const recepients = (action as GetAllRecepientsSuccessAction).recepients;
      return {...state, allRecepients: recepients};
    case MY_MAIL_ALERT:
      const recepient = (action as MyMailAlertAction).payload;
      if (recepient) {
        return {...state, inboxAlertMessage: recepient};
      }
      break;
  }
  return state;
}

